import { AbstractIcon } from './abstract';
import { componentsRegistryService } from 'cruzo';

export class PixelArrowIcon extends AbstractIcon {
    static selector = "pixel-arrow-icon";

    getHTML() {
        return `<svg fill="#000000" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg" id="memory-arrow-right"><path d="M17 10V12H16V13H15V14H14V15H13V16H11V14H12V13H13V12H4V10H13V9H12V8H11V6H13V7H14V8H15V9H16V10" /></svg>`;
    }
}

componentsRegistryService.define(PixelArrowIcon);
